import { Sprout, Facebook, Instagram } from "lucide-react";

const Footer = () => (
  <footer data-testid="footer" className="border-t border-white/10">
    <div className="mx-auto max-w-[1400px] px-6 py-16 lg:px-12 lg:py-20">
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <img src="/assets/zentra-logo-white.png" alt="ZENTRA" className="h-10 w-auto" />
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-[#A6A66A]">
            Everyday Protein. Powered by Microgreens. The protein bar made with horse
            gram microgreens we grow ourselves. Mountain Fresh Farms LLP, Coimbatore.
          </p>
          <div className="mt-6 flex items-center gap-3" data-testid="footer-social-links">
            <a
              href="https://www.facebook.com/zentra.foods"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-facebook-link"
              aria-label="Zentra Foods on Facebook"
              className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-white/70 transition-colors duration-300 hover:border-[#7ED321] hover:text-[#7ED321]"
            >
              <Facebook className="h-4 w-4" />
            </a>
            <a
              href="https://www.instagram.com/zentra.foods?utm_source=qr&stkn=MXdtbjRkM3BueTFocA=="
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram-link"
              aria-label="Zentra Foods on Instagram"
              className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-white/70 transition-colors duration-300 hover:border-[#7ED321] hover:text-[#7ED321]"
            >
              <Instagram className="h-4 w-4" />
            </a>
          </div>
          <p className="mt-6 flex items-center gap-2 text-sm text-white/50">
            <Sprout className="h-4 w-4 text-[#7ED321]" />
            FSSAI-licensed manufacturing
          </p>
        </div>

        <div className="lg:col-span-3 lg:col-start-10">
          <p className="mb-5 text-[11px] font-semibold uppercase tracking-[0.25em] text-white/40">Explore</p>
          <div className="flex flex-col gap-3">
            {[
              ["Home", "/"],
              ["Microgreens", "/microgreens"],
              ["FAQ", "/faq"],
              ["Contact", "/contact"],
              ["Track Order", "/track"],
            ].map(([label, to]) => (
              <a
                key={to}
                href={to}
                data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}
                className="w-fit text-sm text-white/70 transition-colors duration-300 hover:text-[#7ED321]"
              >
                {label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>

    <div className="overflow-hidden border-t border-white/10 py-6" aria-hidden="true">
      <div className="whitespace-nowrap text-center font-display text-[9vw] leading-[0.9] text-white/[0.04] lg:text-[7rem]">
        EVERYDAY PROTEIN. POWERED BY MICROGREENS.
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="mx-auto flex max-w-[1400px] flex-col items-start justify-between gap-3 px-6 py-6 text-[11px] text-white/35 lg:flex-row lg:items-center lg:px-12">
        <span>© 2026 Zentra. All rights reserved.</span>
        <div className="flex flex-wrap items-center gap-x-4 gap-y-1" data-testid="footer-legal-links">
          <a href="/shipping-policy" data-testid="footer-link-shipping-policy" className="transition-colors duration-300 hover:text-[#7ED321]">Shipping Policy</a>
          <a href="/refund-policy" data-testid="footer-link-refund-policy" className="transition-colors duration-300 hover:text-[#7ED321]">Refund Policy</a>
          <a href="/privacy-policy" data-testid="footer-link-privacy-policy" className="transition-colors duration-300 hover:text-[#7ED321]">Privacy Policy</a>
          <a href="/terms" data-testid="footer-link-terms" className="transition-colors duration-300 hover:text-[#7ED321]">Terms &amp; Conditions</a>
        </div>
        <span>
          Microgreen protein · Protein bars India · Plant protein with microgreens · Functional
          nutrition · Sports nutrition · Healthy protein snacks
        </span>
      </div>
    </div>
  </footer>
);

export default Footer;
